'use client'
import type { FC } from 'react'
import { CategoryDTO } from 'ecosystem'
import { MoreCategoriesSlideOut } from 'storefront-modules/categories'
import { useSlideOut } from '#/src/custom/controllers'
import { useAppConfigContext } from '#/src/appConfig'

export interface ISlideOutMoreCategoriesProps {
  category: CategoryDTO
}

const SlideOutMoreCategories: FC<ISlideOutMoreCategoriesProps> = ({ category }) => {
  const appConfig = useAppConfigContext()
  const { closeSlideOut } = useSlideOut()

  return (
    <MoreCategoriesSlideOut
      category={category}
      categoriesUrlPath={appConfig.paths.categoriesUrlPath}
      onClose={closeSlideOut}
    />
  )
}
export default SlideOutMoreCategories
